import { useEffect } from 'react';

import { PLACE_ORDER_RETIRED_URL } from 'modules/onboard/routes/constants';

import strings from './strings';

/**
 * Builds the redirect target for a retired place-order URL. The query string is
 * kept, as the nginx 301 does (`$is_args$args`), so UTM parameters reach the
 * pricing page.
 */
export const getPlaceOrderRedirectUrl = (search = '') => {
  const query = typeof search === 'string' ? search.replace(/^\?/, '') : '';
  return query ? `${PLACE_ORDER_RETIRED_URL}?${query}` : PLACE_ORDER_RETIRED_URL;
};

/**
 * Replaces the retired Chargify checkout `/onboard/place-order/:offerCode`
 * (hubspot-off-block-3 task 98, ADR-014). Full page loads never reach it: nginx
 * answers them with a 301 to the same URL. It covers in-app navigation and
 * local development. It makes no request of its own.
 */
const PlaceOrderRetired = ({ location }) => {
  const target = getPlaceOrderRedirectUrl(location?.search ?? window.location.search);

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <p role="status">
      {strings.redirecting} <a href={target}>{strings.fallbackLink}</a>
    </p>
  );
};

export default PlaceOrderRetired;
